module.exports = __webpack_public_path__ + "fonts/Sarabun-ExtraBoldItalic.47b72fd5.ttf";